export const FOLLOW_UP_LATEST_ACTIVITY = {
    TASK: "FOLLOW_UP",
    EMAIL: "EXTERNAL_EMAILS",
};
